function DazProxy1155XC(address, cfg, chainId, proxyContract = null) {
    address = dazethutil.toLower(address);
    this.address = address;
    if (proxyContract === null) {
        proxyContract = cfg.proxies.contractName;
    }
    this.name = cfg.proxies.list[address].name;
    this.contracts = [];
    this.effect = {};
    this.types = cfg.proxies.list[address].types;
    this.config = cfg || {};
    this.allowedTypes = {};
    this.eth = window.dazeth;
    this.chainId = chainId;
}

DazProxy1155XC.prototype.Init = async function () {
    this.contracts = await this.getAllowedContracts();
    return this.load('effect', {proxy: this.address}).then(async effect => {
        this.effect = new DazContract1155XC(effect, this.config, this.address);
        for (let i in this.contracts) {
            await this.loadTypes(this.contracts[i]);
        }
    })
}

DazProxy1155XC.prototype.getMyUpgrades = async function (address) {
    let upgrades = {};
    let types = [];
    for (let addr in this.types) {
        for (let i in this.types[addr]) {
            let tt = this.types[addr][i];
            if (!this.allowedTypes[addr][tt]) {
                continue;
            }
            if (types.indexOf(tt) === -1) {
                types.push(tt);
            }
        }
    }

    const qty = await this.load('getMyUpgrades', { types: types} );
    for (let i in types) {
        if (qty[i] === 0) {
            continue;
        }
        let tt = types[i];
        upgrades[tt] = {qty: parseInt(qty[i], 10), type: tt};
    }
    return upgrades;
}

DazProxy1155XC.prototype.loadTypes = async function (address) {
    this.allowedTypes[address] = {};
    for (let i = 0; i < this.types[address].length; i++) {
        let tt = this.types[address][i];
        this.allowedTypes[address][tt] = await this.isTypeAllowed(address, tt);
    }
}

DazProxy1155XC.prototype.isTypeAllowed = async function (address, tokenType) {
    return true;
}

DazProxy1155XC.prototype.typeOfToken = async function (token) {
    return token;
}

DazProxy1155XC.prototype.tokenTypes = async function (address) {
    return this.types[address];
}

DazProxy1155XC.prototype.getAllowedContracts = async function () {
    return dazethutil.toLower(Object.keys(this.types));
}

DazProxy1155XC.prototype.upgradedTokenList = function (address, token) {
    return [];
}

DazProxy1155XC.prototype.canUpgrade = async function (address, token, tokenType = false) {
    return false;
}

DazProxy1155XC.prototype.canUpgradeWithToken = async function (address, token, withToken) {
    return false;
}

DazProxy1155XC.prototype.upgrade = function (upgradeToken, address, index, data = "", onHash = null) {
    throw 'not allowed';
}

DazProxy1155XC.prototype.load = async function (method, data) {
    if (!window.dazXC) {
        throw 'Not cross chain proxy';
    }

    const xc = window.dazXC();
    const rData = xc.data(Object.assign({}, data, {
        who: dazethutil.me(),
        contract: this.effect.address,
        now: (new Date).getTime(),
        chainID: this.chainId,
    }));
    return fetch( "/nft-api/nfp/gen1/bridge/erc1155/proxy/" + method, {
        method: 'POST',
        mode: 'cors',
        body: (new URLSearchParams(rData)).toString(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
    }).then((response) => {
        if (!response.ok) {
            throw "could not load";
        }
        return response.json();
    });
}
